(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('free-shipping-bar')) {
    class FreeShippingBar extends HTMLElement {
      connectedCallback() {
        this.message = this.querySelector('[data-free-shipping-message]');
        this.abortController = null;
        this.unsubscribe = null;
        this.boundRefresh = this.refresh.bind(this);
        this.render(Number(this.dataset.total), Number(this.dataset.itemCount));
        this.connectToCartEvents();
        document.addEventListener('cart:updated', this.boundRefresh);
        document.addEventListener('cart:refresh', this.boundRefresh);
      }

      disconnectedCallback() {
        if (typeof this.unsubscribe === 'function') this.unsubscribe();
        if (this.abortController) this.abortController.abort();
        document.removeEventListener('cart:updated', this.boundRefresh);
        document.removeEventListener('cart:refresh', this.boundRefresh);
      }

      connectToCartEvents() {
        const connect = () => {
          if (this.unsubscribe) return;
          if (typeof subscribe !== 'function') return;
          if (typeof PUB_SUB_EVENTS === 'undefined') return;

          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.boundRefresh);
        };

        connect();

        if (!this.unsubscribe) {
          document.addEventListener('DOMContentLoaded', connect, { once: true });
          window.setTimeout(connect, 500);
        }
      }

      async refresh() {
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart.js`, {
            headers: { Accept: 'application/json' },
            cache: 'no-store',
            signal: this.abortController.signal
          });

          if (!response.ok) return;

          const cart = await response.json();
          this.render(Number(cart.total_price), Number(cart.item_count));
        } catch (error) {
          if (error.name !== 'AbortError') return;
        }
      }

      render(total, itemCount) {
        const goal = Number(this.dataset.goal);
        if (!goal || !this.message) return;

        const safeTotal = Number.isFinite(total) ? total : 0;
        const remaining = Math.max(goal - safeTotal, 0);

        if (itemCount === 0) {
          this.dataset.status = 'empty';
          this.message.textContent = this.dataset.messageEmpty;
          return;
        }

        if (remaining > 0) {
          this.dataset.status = 'pending';
          this.message.textContent = this.dataset.messageIncomplete.replace(
            '[amount]',
            this.formatMoney(remaining)
          );
          return;
        }

        this.dataset.status = 'complete';
        this.message.textContent = this.dataset.messageComplete;
      }

      formatMoney(cents) {
        const currency = this.dataset.currency || 'COP';
        return new Intl.NumberFormat('es-CO', {
          style: 'currency',
          currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(cents / 100).replace(/\s/g, '');
      }
    }

    customElements.define('free-shipping-bar', FreeShippingBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
